export default function BasicCardWithButtons({title, children, style, size, buttons} : {title: string, children: any, style?: any, size?:any, buttons: any}){
  const cardClass = `card-title ${size ? `${size}` : ''}`;
  return (
      <div className="otros-documentos-card" style={{...style}}>
          {title &&
          <>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap'}}>
            <h3 className={cardClass}>{title}</h3>
            {buttons}
          </div>
          <div className="separador"/>
          </>
          }
          {children}
      </div>
  )
}